import ECharts from '../../ECharts';
import { getFinancialData } from '../../../pages/ManageInvestments/components/FinancialChartModal';
import { getMinMax, toPlainString, getMinMax } from '../../../utils/helpers';
import { formatDisplayNumber } from '../../../utils/format';

export default function FinancialChart({ financialData, isDarkMode }) {
  const getChartOptions = () => {
    const {
      xAxisData,
      seriesData,
      tmpProfitData,
    } = getFinancialData(financialData, [
      'lnsauthue',
      'doanhthuthuan',
      'tongnophaitra',
    ]);
    const bgColor = isDarkMode ? '#1a1c23' : '#fff';
    const color = isDarkMode ? '#e5e7eb' : '#24262d';
    const minMax = getMinMax(tmpProfitData);
    let min = minMax[0];
    let max = minMax[1];
    if (minMax[0] < 0) {
      if (min < 0 && max > 0) {
        if (min * -1 > max) {
          max = min * -1;
        } else {
          min = max * -1;
        }
      } else if (min < 0 && max < 0) {
        max = min * -1;
      } else if (min > 0) {
        min = max * -1;
      }
    } else {
      min = 0;
    }
    return {
      backgroundColor: bgColor,
      tooltip: {
        trigger: 'axis',
        formatter(params) {
          let html = '';
          for (let i = 0; i < params.length; i++) {
            html += `
              <div class="flex justify-between w-full">
                <div class="mr-4">${params[i].marker} ${
              params[i].seriesName
            }:</div>
                <div class="font-bold">${formatDisplayNumber(
                  params[i].value
                )} tỷ</div>
              </div>
            `;
          }
          return `
            <div>
              <div class="font-bold">${params[0].axisValue}</div>
              <div>${html}</div>
            </div>
          `;
        },
      },
      grid: {
        left: 70,
        right: 10,
        top: 10,
        bottom: 30,
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            show: true,
          },
          data: xAxisData,
          axisLabel: {
            color,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            show: true,
            formatter(value) {
              let newValue = parseFloat(
                Number(toPlainString(value)).toFixed(2)
              );
              return `${formatDisplayNumber(newValue, ',', 0)} tỷ`;
            },
            color,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
          min,
          max,
          interval: (max - min) / 6,
        },
      ],
      series: seriesData,
    };
  };
  return (
    <div>
      <ECharts options={{ ...getChartOptions() }} height="250px" notMerge />
      <ul className="flex items-center mb-3 flex-wrap sm:flex-nowrap">
        <li className="mr-4 mb-2 sm:mb-0 flex items-center">
          <span
            className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-1"
            style={{ backgroundColor: '#e1c103' }}
          ></span>
          <span>Doanh thu thuần</span>
        </li>
        <li className="mr-4 mb-2 sm:mb-0 flex items-center">
          <span
            className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-1"
            style={{ backgroundColor: '#008e00' }}
          ></span>
          <span>Lợi nhuận ròng</span>
        </li>
        <li className="mb-2 sm:mb-0 flex items-center">
          <span
            className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-1"
            style={{ backgroundColor: '#b30303' }}
          ></span>
          <span>Tổng nợ vay</span>
        </li>
      </ul>
    </div>
  );
}
